import {Component, Inject, OnInit, Optional, PLATFORM_ID} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import {filter, map} from 'rxjs/operators'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {LinkService} from '../../../../core/i18n/link.service'
import {RESPONSE} from '../../../../../../server/express.tokens'
import type {Response} from 'express'
import {isPlatformServer} from '@angular/common'
import {EPHEMERAL_404} from '../../../../../../server/status'
import {ArticleLanguageAvailability} from '../../../../core/content/types/article.types'

@Component({
  templateUrl: './article-language-unavailable-page.component.html',
  standalone: false,
})
export class ArticleLanguageUnavailablePageComponent implements OnInit {
  availableLanguages$ = this.route.data.pipe(
    map(data => data['availability']),
    filter((page): page is ArticleLanguageAvailability => !!page),
    map(page =>
      page.activeLocales.map(lang => ({
        lang,
        path: this.linkService.localizedPathTo(PUBLIC_ROUTES.ARTICLE_PAGE, {routeParams: {pageSlug: page.slug}}, lang),
      })),
    ),
  )

  constructor(
    private route: ActivatedRoute,
    protected linkService: LinkService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    @Optional() @Inject(RESPONSE) private readonly response: Response,
  ) {}

  ngOnInit(): void {
    if (isPlatformServer(this.platformId) && this.response) {
      this.response.status(EPHEMERAL_404)
    }
  }
}
